<template>
  <v-popup
    class="groupon-end-popup"
    v-if="recommendInit"
    v-model="show"
    position="bottom"
    :close-on-click-overlay="false"
  >
    <div class="groupon-end" v-if="result">
      <div class="result">
        <template v-if="result.status == 1">
          <img src="../img/end.png" alt="" class="result-img" />
          <p class="result-desc">拼购活动已结束</p>
        </template>
        <template v-else-if="result.status == 2">
          <img src="../img/empty.png" alt="" class="result-img" />
          <p class="result-desc">商品已被抢光了</p>
        </template>
      </div>

      <div class="recommend" v-if="recommendList && recommendList.length">
        <p class="title">
          <span class="text">
            <i class="line line--left"></i>
            其他热门拼团
            <i class="line line--right"></i>
          </span>
        </p>
        <ul class="list">
          <li class="list-item" v-for="(item, i) in recommendList" :key="item.spuId + i">
            <a :href="item.prodUrl" class="item-link">
              <p class="img">
                <img :src="item.skuImgUrl" />
                <span class="tag">
                  <i>{{ item.actTag }}</i>
                </span>
              </p>
              <div class="info">
                <p class="name">{{ item.prodName }}</p>
                <p class="number">{{ item.actStateDesc }}</p>
                <p class="price">
                  <span class="price--group">￥{{ item.actPrice }}</span>
                  <span class="price--through">￥{{ item.marketPrice }}</span>
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <div class="btns">
        <v-button type="frame-plus" v-if="result.commodityFlag == 1" position="center" @click="quickBuy">
          ￥{{ skuInfo.salePrice || skuInfo.commoditySkuBaseInfo.salePrice }}购买
        </v-button>
        <v-button type="cancel" @click="toMore" position="center" v-if="result.otherGroupons">更多拼团</v-button>
      </div>
    </div>
  </v-popup>
</template>
<script>
import { confirmBuy } from 'components/buy-flow/utils.js'
import { getGrouponRecomendReq } from './api'
import API from '@/api'
export default {
  name: 'groupon-end-popup',
  props: {
    result: {
      type: Object,
      require: true,
      default() {
        return {}
      }
    },
    selectData: Object,
    spuInfo: Object,
    spuId: [String, Number],
    skuInfo: Object,
    commonBuy: Function
  },
  data: function () {
    return {
      show: true,
      recommendInit: false,
      recommendList: [],
      grouponType: 0, // 拼团类型
      goodsType: 1
    }
  },
  computed: {
    failText() {
      if (this.result.status == 1) {
        return '拼购活动已结束'
      } else if (this.result.status == 2) {
        return '商品已被抢光了'
      }
    }
  },
  created() {
    let goodsType = this.spuInfo?.commoditySpu.cmmdyTypeId
    if (goodsType) {
      this.goodsType = goodsType
    }
    if (this.selectData) {
      if (this.selectData.grouponType) {
        this.grouponType = this.selectData.grouponType
      }
      if (this.selectData.goodsType) {
        this.goodsType = this.selectData.goodsType
      }
    }
    if (this.result?.recommends?.length > 0) {
      this.recommendList = this.result.recommends
      this.recommendInit = true
    } else {
      // 参数兼容新老接口
      getGrouponRecomendReq({
        spuId: this.spuInfo?.commoditySpu?.id || this.spuId,
        skuId: this.skuInfo?.id || this.skuInfo?.commoditySkuBaseInfo?.skuId,
        promotionId:
          this.spuInfo?.grouponInfo?.promotionId ||
          this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityGroupon?.promotionId ||
          this.spuInfo?.spuFirstDiscount?.promotionId ||
          0
      })
        .then(res => {
          this.recommendList = res || []
        })
        .finally(() => {
          this.recommendInit = true
        })
    }
    API.logAll({
      cfrom: '138|001|02|077',
      event_id: '138|001|02|077',
      goodtype: this.goodsType,
      goodid: this.skuInfo?.id || this.skuInfo?.commoditySkuBaseInfo?.skuId,
      stateval: this.failText,
      module: this.grouponType == 1 ? 2 : 1
    })
  },
  methods: {
    toMore() {
      if (this.result && this.result.otherGroupons) {
        API.logAll({
          cfrom: '138|002|01|077',
          event_id: '138|002|01|077',
          goodtype: this.goodsType,
          goodid: this.skuInfo?.id || this.skuInfo?.commoditySkuBaseInfo?.skuId,
          stateval: this.failText,
          module: this.grouponType == 1 ? 2 : 1
        })

        window.location.href = this.result.otherGroupons
      }
    },
    quickBuy() {
      API.logAll({
        cfrom: '138|003|01|077',
        event_id: '138|003|01|077',
        goodtype: this.goodsType,
        goodid: this.skuInfo?.id || this.skuInfo?.commoditySkuBaseInfo?.skuId,
        stateval: this.failText,
        module: this.grouponType == 1 ? 2 : 1
      })

      // 新老商详兼容
      if (this.commonBuy) {
        this.commonBuy()
        return
      }
      confirmBuy({
        operateType: 3, // 拼团活动的单独购买，传3
        selectData: this.selectData,
        spuInfo: this.spuInfo,
        skuInfo: this.skuInfo
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss" />
<style lang="scss" scoped>
.vivo-fontscale-5{
  .groupon-end-popup .recommend .list-item .img .tag{
    width: 124px !important;
    background-size: 100% 100% !important;
  }
}
</style>
